import { MAIN_COLOR } from 'shared/consts';
import styled from 'styled-components';

type MarginBottomProps = {
  $value?: string;
}

export const MarginBottom = styled.div<MarginBottomProps>`
  ${props => {
    if (props.$value) {
      return `margin-bottom: ${props.$value};`
    } else {
      return `
        margin-bottom: 40px;
        @media (max-width:580px){
          margin-bottom: 12px;
        }
      `
    }
  }}
`;

export const Circle = styled.div`
	width: 100px;
	height: 100px;
	border-radius: 100%;
	background: ${MAIN_COLOR};
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	font-weight: 600;

  img {
    max-width: 100%;
    max-height: 65%;
  }

  @media (max-width:580px){
    width: 52px;
    height: 52px;
  }
`;

export const ButtonsContainer = styled.div`
  @media (min-width:580px){
    margin-left: 50px;
    margin-right: 50px;
  }
  @media (max-width:580px){
    padding-left: 16px;
    padding-right: 16px;
  }
`;
